import { BASIC_INITIAL_STATE } from '@usas/ui-web/utils/HttpHelper';

import getOtsOfficialMeetHistoryByPersonId from './GetOtsOfficialMeetHistoryByPersonIdData';

const INITIAL_STATE = {
  ...BASIC_INITIAL_STATE
};

const OtsOfficialMeetHistoryData = {
  INITIAL_STATE: { ...INITIAL_STATE },
  getOtsOfficialMeetHistoryByPersonId
};

export default OtsOfficialMeetHistoryData;